import compose from "recompose/compose";
import withState from "recompose/withState";
import mapProps from "recompose/mapProps";
import lifecycle from "recompose/lifecycle";
import { useEffect, useState } from "react";

const SESSION_KEY = "__SESSION_SELF_DESTRUCTED_DATA__";

const getFlashMessages = (rootMemory, messagesKey = "messages") =>
  rootMemory?.[SESSION_KEY]?.[messagesKey];
const clearFlashMessages = (rootMemory, messagesKey = "messages") => {
  if (getFlashMessages(rootMemory, messagesKey)) {
    delete rootMemory[SESSION_KEY][messagesKey];
  }
};

/**
 * @param {Object} [rootMemory]
 * @param {string} [messagesKey]
 * @returns {[Array, Function]}
 */
const useFlashMessages = (rootMemory, messagesKey = "flashMessages") => {
  rootMemory = rootMemory ?? (typeof window !== "undefined" ? window : null);
  const [flashMessages, setFlashMessages] = useState([]);
  const messages = getFlashMessages(rootMemory, messagesKey);
  useEffect(() => {
    if (messages) {
      setFlashMessages(messages);
    }
  }, [messages]);
  const flushMessages = () => {
    clearFlashMessages(rootMemory, messagesKey);
    setFlashMessages([]);
  };
  return [flashMessages, flushMessages];
};

const withFlashMessages = (rootMemory, messagesKey = "messages") => {
  const getMessages = () => getFlashMessages(rootMemory, messagesKey);
  const clearMessages = () => clearFlashMessages(rootMemory, messagesKey);

  return compose(
    withState(
      "flashMessages",
      "setFlashMessages",
      (props) => props?.flashMessages ?? []
    ),
    lifecycle({
      componentDidMount() {
        this.props.setFlashMessages(
          this.props.flashMessages.concat(getMessages() || []),
          clearMessages
        );
      },
    }),
    mapProps(({ setFlashMessages, ...props }) => ({ ...props }))
  );
};

export default withFlashMessages;
export { useFlashMessages };
